import { observer } from 'mobx-react-lite';
import React from 'react';

import { Icon, IconDelete, IconEdit, IconUserAdd } from '@flixbus/honeycomb-icons-react';
import { Button } from '@flixbus/honeycomb-react';

import { addMembersStore } from 'pages/Profile/components/AddMembersModal/AddMembersStore';
import { manageGroupDataStore } from 'pages/Profile/components/ManageGroupDataModal/ManageGroupDataStore';
import { groupsStore } from 'pages/Profile/GroupsStore';

import styles from './styles.module.css';

const GroupControls = observer(({ groupId }) => {
	return (
		<div
			onClick={(e) => {
				e.stopPropagation();
				e.preventDefault();
			}}
			className={styles.groupControls}
		>
			<Button
				onClick={() => addMembersStore.triggerAddMembers(groupId)}
				display="square"
				aria-label="Add members"
			>
				<Icon InlineIcon={IconUserAdd} aria-hidden="true" />
			</Button>
			<Button
				onClick={() =>
					manageGroupDataStore.activateManageGroupDataModal(true, groupsStore.getGroup(groupId))
				}
				display="square"
				aria-label="Edit group"
			>
				<Icon InlineIcon={IconEdit} aria-hidden="true" />
			</Button>
			<Button
				onClick={() => groupsStore.triggerDeleteMode(groupId)}
				display="square"
				aria-label="Delete group"
			>
				<Icon InlineIcon={IconDelete} aria-hidden="true" />
			</Button>
		</div>
	);
});

export default GroupControls;
